import firebase from "firebase/app";
const actions = {
	fetchDefaults: ({ commit }) => {
		firebase
			.firestore()
			.collection("settings")
			.doc("defaults")
			.onSnapshot({ includeMetadataChanges: true }, defaults => {
				commit("setDefaults", defaults.data());
			});
	},

	fetchSkills: ({ commit }) => {
		firebase
			.firestore()
			.collection("settings")
			.doc("skills")
			.onSnapshot({ includeMetadataChanges: true }, skills => {
				commit("setSkills", skills.data());
			});
	},

	fetchPortfolio: ({ commit }) => {
		firebase
			.firestore()
			.collection("settings")
			.doc("stacks")
			.onSnapshot({ includeMetadataChanges: true }, portfolio => {
				commit("setPortfolio", portfolio.data().stacks);
				commit("setCategories", portfolio.data().categories);
			});
	},

	fetchExperience: ({ commit }) => {
		firebase
			.firestore()
			.collection("settings")
			.doc("work")
			.onSnapshot({ includeMetadataChanges: true }, exp => {
				commit("setExp", exp.data().experiences);
			});
	},
};

export default actions;
